<template>
  <div>
    <card
      :headerClasses="headerColor"
      class="no-border-card"
      body-classes="px-0 pb-1"
      footer-classes="pb-2"
    >
      <b-row align-v="center" slot="header">
        <b-col cols="8">
          <h3 class="mb-0 text-white">{{ title }}</h3>
        </b-col>

        <b-col cols="4" class="text-right">
          <b-button
            @click="openInputModal()"
            style="font-size: large"
            variant="primary"
            size="sm"
            icon
          >
            <i class="no no-plus text-white"></i>
          </b-button>

          <b-dropdown
            menu
            on
            right
            no-caret
            id="dropdown-1"
            variant="boton"
            style="padding: 0"
            class="dropdown-input-transaction"
          >
            <template v-slot:button-content>
              <svg
                width="5"
                height="19"
                viewBox="0 0 5 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="2.19231" cy="2.19231" r="2.19231" fill="#FFF" />
                <circle cx="2.19231" cy="9.49992" r="2.19231" fill="#FFF" />
                <circle cx="2.19231" cy="16.8078" r="2.19231" fill="#FFF" />
              </svg>
            </template>

            <b-dropdown-item
              @click="downloadAsCSV(true)"
              active
              :loading="queriedData.length > 0"
              style="border-top: 1px solid #ffffff8c"
              type="default"
            >
              <i
                class="ni ni-cloud-download-95 text-white"
                title="baixar Relatório Simplificado"
              ></i>
              Relatório Simplificado
            </b-dropdown-item>

            <b-dropdown-item
              @click="downloadAsCSVFiscal(true)"
              active
              :loading="queriedData.length > 0"
              style="border-top: 1px solid #ffffff8c"
              type="default"
            >
              <i
                class="ni ni-cloud-download-95 text-white"
                title="baixar Relatório Fiscal"
              ></i>
              Relatório Fiscal
            </b-dropdown-item>

            <b-dropdown-item
              @click="downloadAsCSVProducts(true, 'Passeio')"
              active
              :loading="queriedData.length > 0"
              style="border-top: 1px solid #ffffff8c"
              type="default"
            >
              <i
                class="ni ni-cloud-download-95 text-white"
                title="baixar Relatório por produtos"
              ></i>
              Relatório de Passeios
            </b-dropdown-item>
          </b-dropdown>

          <div class="text-right"></div>
        </b-col>
      </b-row>
      <b-row class="px-3">
        <b-col cols="3">
          <el-select
            class="select-primary pagination-select"
            v-model="pagination.perPage"
            placeholder="Per page"
          >
            <el-option
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
              class="select-primary"
            >
            </el-option>
          </el-select>
        </b-col>
        <b-col cols="9">
          <div
            class="d-flex align-items-center w-100"
            style="
              padding: 7px;
              border: 0.5px solid rgb(218, 218, 218);
              border-radius: 5px;
              background-color: white;
            "
          >
            <input
              class="search-input w-100"
              v-model="searchQuery"
              placeholder="filtrar"
            />
            <button
              v-if="searchQuery"
              type="button"
              class="search-field-clear"
              title="Limpar busca"
              @click="searchQuery = ''"
            >
              <i class="fas fa-times"></i>
            </button>
            <i v-else class="fas fa-search text-muted"></i>
          </div>
        </b-col>
      </b-row>

      <el-table
        :data="queriedData"
        :row-key="(row) => row.id"
        header-row-class-name="thead-light"
        @sort-change="sortChange"
        @selection-change="selectionChange"
        :expand-row-keys="expandRowKeys"
        @expand-change="handleExpandChange"
        :row-class-name="'px-3'"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="expand-content">
              <b-table
                :items="
                  props.row.xfields && props.row.xfields.general
                    ? [props.row.xfields.general]
                    : []
                "
                :fields="expandTableColumns"
                small
                stacked
              >
                <template #cell(date)="data">
                  {{
                    new Date(`${data.item.date} 12:00:00`).toLocaleDateString(
                      'pt-BR'
                    )
                  }}
                </template>

                <template #cell(bill_final_value)="data">
                  {{
                    data.item.bill_final_value == '--'
                      ? data.item.bill_final_value
                      : 'R$ ' +
                        data.item.bill_final_value
                          .toFixed(2)
                          .toLocaleString('pt-BR')
                          .replace('.', ',')
                  }}
                </template>
              </b-table>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          v-for="column in tableColumns"
          :key="column.label"
          v-bind="column"
        >
          <template #default="scope">
            <div
              @click="handleEdit(scope.$index, scope.row)"
              class="table-cell-clickable"
            >
              {{
                column.formatter
                  ? column.formatter(
                      scope.row,
                      column,
                      scope.row[column.prop],
                      scope.$index
                    )
                  : scope.row[column.prop]
              }}
            </div>
          </template>
        </el-table-column>

        <el-table-column v-if="false" label="Ações">
          <template #default="scope">
            <span
              v-if="scope.row.pid != null"
              @click="handleEdit(scope.$index, scope.row)"
              class="pl-2 btn-inner--icon"
              type="button"
            >
              <i class="no-lg no no-view text-indigo circle"></i>
            </span>

            <span v-else class="pl-2 btn-inner--icon" type="button">
              <i class="no-lg no no-view text-gray circle"></i>
            </span>
          </template>
        </el-table-column>
      </el-table>

      <div
        slot="footer"
        class="col-12 pa-0 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <div>
          <h5>
            Total pago:
            <span method="" class="font-weight-light">{{
              totalPago.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })
            }}</span>
          </h5>
          <h5>
            Total previsto:
            <span class="font-weight-light">{{
              totalPrevisto.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })
            }}</span>
          </h5>
          <h5>
            A pagar:
            <span class="font-weight-light">{{
              totalDifference.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })
            }}</span>
          </h5>
        </div>
      </div>

      <div
        slot="footer"
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <div class="">
          <p class="card-category">
            Mostrando {{ from + 1 }} a {{ to }} de {{ total }} entradas

            <span v-if="selectedRows.length">
              &nbsp; &nbsp; {{ selectedRows.length }} linhas selecionadas
            </span>
          </p>
        </div>

        <base-pagination
          class="pagination-no-border"
          :current="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
          @change="paginationChanged($event)"
        >
        </base-pagination>
      </div>
    </card>

    <modal-loading
      :openModal="isLoading"
      :value="'100'"
      :label="'carregando... '"
      :variant="'white'"
      :animated="false"
    >
    </modal-loading>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Form, FormItem } from 'element-ui'
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import ModalLoading from '../../components/ModalLoading/ModalLoading.vue'
import { BasePagination } from '@/components'
import usePaginateTable from '../../Composables/usePaginateTable'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'FinanceiroTable',

  setup(props, context) {
    const paginateTable = usePaginateTable(context)

    const total = paginateTable.total
    const from = paginateTable.from
    const to = paginateTable.to
    const queriedData = paginateTable.queriedData
    const pagination = paginateTable.getPagination()
    const billItems = paginateTable.getBillsItems()
    const searchQuery = paginateTable.searchQuery

    function formatDataLocaleString(oldData) {
      return paginateTable.formatDataLocaleString(oldData)
    }
    function sortChange(data) {
      return paginateTable.sortChange(data)
    }
    function createFuseSearch(keys) {
      return paginateTable.createFuseSearch(keys)
    }
    function setBillItems(items) {
      return paginateTable.setBillsItems(items)
    }

    return {
      total,
      from,
      to,
      queriedData,
      pagination,
      billItems,
      searchQuery,
      formatDataLocaleString,
      sortChange,
      createFuseSearch,
      setBillItems,
    }
  },

  components: {
    BasePagination,
    RouteBreadCrumb,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    ModalLoading,
  },

  props: {
    title: {
      type: String,
    },

    headerColor: {
      type: String,
    },

    startDate: {
      type: String,
    },

    endDate: {
      type: String,
    },
  },

  data() {
    return {
      expandRowKeys: [],
      isLoading: false,
      tableColumns: [
        {
          prop: 'p',
          label: 'Recebido em',
          minWidth: 160,
          formatter: (row, col, cell, index) => this.formatterData(row),
          sortable: true,
        },
        {
          prop: 't',
          label: 'Descrição',
          minWidth: 200,
          formatter: (row, col, cell, index) => this.formatterDescricao(row),
          sortable: true,
        },
        {
          prop: 'v',
          label: 'Valor',
          minWidth: 120,
          formatter: (row, col, cell, index) => this.formatterMoeda(row),
          sortable: true,
        },
        {
          prop: 'd',
          label: 'Previsão',
          minWidth: 135,
          formatter: (row, col, cell, index) => this.formatterDataPrevisao(row),
          sortable: true,
        },
      ],
      expandTableColumns: [
        { key: 'label', label: 'Rótulo', minWidth: 135, sortable: false },
        { key: 'user.name', label: 'Usuário', minWidth: 135, sortable: false },
        {
          key: 'date',
          label: 'Data',
          minWidth: 160,
          formatter: (row, col, cell, index) => this.formatterData(row),
          sortable: false,
        },
        {
          key: 'bill_final_value',
          label: 'Valor',
          minWidth: 160,
          formatter: (row, col, cell, index) => this.formatterMoeda(row),
          sortable: false,
        },
      ],
      selectedRows: [],
      searchQueryValue: '',
    }
  },

  watch: {
    inputTransactions(newValue, oldValue) {
      if (newValue) {
        this.recreateSearchableTable()
      }
    },
  },

  computed: {
    ...mapGetters('financeiro', {
      inputTransactions: 'getInputTransactionsList',
      transaction: 'getInputTransaction',
    }),

    ...mapGetters('auth', {
      user: 'user',
    }),

    totalPago() {
      var totalPago = 0

      const valorRecebido = (this.inputTransactions || []).map((element) => {
        if (!element) return
        if (element.d === element.p || element.hasOwnProperty('p')) {
          return Number(element.v)
        }
      })

      if (!valorRecebido.every((value) => isNaN(value))) {
        let sumPago = valorRecebido.reduce((prev, curr) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return prev + curr
          } else {
            return prev
          }
        }, 0)

        totalPago = sumPago
      }

      return totalPago
    },

    totalPrevisto() {
      var totalPrevisto = 0
      const values = (this.inputTransactions || []).map((item) =>
        item ? Number(item.v) : NaN
      )

      if (!values.every((value) => isNaN(value))) {
        let sum = values.reduce((prev, curr) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return prev + curr
          } else {
            return prev
          }
        }, 0)

        totalPrevisto = sum
      }

      return totalPrevisto
    },

    totalDifference() {
      return this.totalPrevisto - this.totalPago
    },
  },

  methods: {
    ...mapActions('financeiro', [
      'financeiroStoreCommit',
      'fetchTransactionById',
    ]),

    downloadAsCSVProducts(reladTransactions, category) {
      if (reladTransactions === true) {
        this.searchQueryValue = String(this.searchQuery)
        this.searchQuery = ''
        setTimeout(() => {
          this.$emit('loadTransactions')
          this.downloadAsCSVProducts(false, category)
        }, 0)
        return
      }

      let currentPerpage = this.pagination.perPage
      let currentPage = this.pagination.currentPage
      let maxPerpage = JSON.parse(
        JSON.stringify(this.pagination.perPageOptions)
      ).pop()
      this.perPageChange(maxPerpage)

      var mat = []
      this.queriedData.map(function (payment) {
        let transactionData = {}

        try {
          transactionData =
            typeof payment.xfields === 'string'
              ? JSON.parse(payment.xfields)
              : payment.xfields
        } catch (error) {
          console.log('erro ao gerar relatório', error)
          alert('erro ao gerar relatório')
          return
        }

        let currPaymentCustomerNames = transactionData.payments.reduce(
          (prev, curr) => {
            if (curr.customer_name) {
              prev.push(curr.customer_name)
            }
            return prev
          },
          []
        )

        let currPaymentCustomerDocuments = transactionData.payments.reduce(
          (prev, curr) => {
            if (curr.customer_document) {
              prev.push(curr.customer_document)
            }
            return prev
          },
          []
        )
        transactionData.products.map((product) => {
          if(product.item.discount == 0 && product.item.final_price != product.item.price ) {
            product.item.final_price = Number(product.item.price);
            console.warn('product.item.final_price',product.item.final_price);
          }
          if (product.item.type == category) {
            mat.push([
              //id da transação
              transactionData.general.date.replaceAll('-', '') +
                '.' +
                transactionData.general.id +
                '-' +
                product.item.uuid,

              // 'Colaborador'
              `"${transactionData.general.user.name}"`,

              // 'Rótulo',
              `"${payment.t.replace('#', '').replace('(parcial)', '').trim()}"`,

              // 'Passeio'
              `"${product.item.product_name}${
                product.item.subcategory
                  ? ` (${product.item.subcategory})`
                  : ''
              }"`,

              // 'Local'
              `"${product.booking.product_place}"`,

              // 'QTDE Pax\'s'
              `"${product.booking.people}"`,

              //data
              `"${product.booking.date}"`,

              //horário
              `"${product.booking.time}"`,

              // 'Obs:'
              `"${product.booking.observation}"`,

              // 'Valor Total'
              `"${Number(product.item.price).toFixed(2).replace('.', ',')}"`,

              // 'DESCONTO'
              `"${Number(product.item.discount).toFixed(2).replace('.', ',')}"`,

              // Valor Final
              `"${Number(product.item.final_price)
                .toFixed(2)
                .replace('.', ',')}"`,

              // 'Motivo dos descontos'
              `"${product.item.observation.replace('#', '').trim()}"`,

              // Cliente: nomes
              `"${currPaymentCustomerNames.join(' | ') || '--'}"`.trim(),

              // Cliente: documents
              `"${currPaymentCustomerDocuments.join(' | ') || '--'}"`.trim(),
            ])
          }
        })
      })

      mat.unshift([
        'ID',
        'Colaborador',
        'Rótulo',
        'Passeio',
        'Local',
        "QTDE Pax's",
        'Data',
        'Horário',
        'Observações',
        '"Valor (R$ 0,00)"',
        'Desconto',
        '"Valor Final (R$ 0,00)"',
        'Motivos dos descontos',
        'Cliente: nomes',
        'Cliente: documentos',
      ])

      var universalBOM = '\uFEFF'
      let csvContent =
        'data:text/csv;charset=utf-8,' +
        universalBOM +
        mat
          .map((e) => e.join(';'))
          .join('\n')
          .toUpperCase()
      var encodedUri = encodeURI(csvContent)
      var link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute(
        'download',
        `${this.user.username}_janoo_vendas_passeios_-_${this.startDate}_-_${
          this.endDate
        }_${new Date().getTime()}.csv`
      )
      document.body.appendChild(link)

      link.click()
      this.perPageChange(currentPerpage)
      this.pagination.currentPage = currentPage
      setTimeout(() => {
        this.searchQuery = this.searchQueryValue
      }, 3000)
    },

    downloadAsCSVFiscal(reladTransactions) {
      if (reladTransactions === true) {
        this.searchQueryValue = String(this.searchQuery)
        this.searchQuery = ''
        setTimeout(() => {
          this.$emit('loadTransactions')
          this.downloadAsCSVFiscal()
        }, 0)
        return
      }
      let currentPerpage = this.pagination.perPage
      let currentPage = this.pagination.currentPage
      let maxPerpage = JSON.parse(
        JSON.stringify(this.pagination.perPageOptions)
      ).pop()
      this.perPageChange(maxPerpage)

      var mat = this.queriedData.map(function (payment, index) {
        let transactionData = {}
        let currPaymentData = false
        let bookingNames = ''
        let bookingPlaces = ''
        let bookingPeople = '--'
        let bookingObs = '--'
        let bookingDates = '--'
        let bookingTimes = '--'
        let productDiscounts = '--'
        let productDiscountObs = ''

        try {
          transactionData =
            typeof payment.xfields === 'string'
              ? JSON.parse(payment.xfields)
              : payment.xfields
        } catch (error) {
          console.log('erro ao gerar relatório', error)
          alert('erro ao gerar relatório')
          return
        }

        currPaymentData = transactionData.payments.find(
          (pm) => Number(pm.id) === Number(payment.id)
        )

        bookingNames = transactionData.products
          .filter((product) => product.item.type === 'Passeio')
          .reduce((prev, curr) => {
            const name = curr.item.product_name || '--'
            prev.push(
              curr.item.subcategory ? `${name} (${curr.item.subcategory})` : name
            )
            return prev
          }, [])
          .join(' | ')

        bookingPlaces = transactionData.products
          .filter((product) => product.item.type === 'Passeio')
          .reduce((prev, curr) => {
            prev.push(curr.booking.product_place || '--')
            return prev
          }, [])
          .join(' | ')

        bookingPeople = transactionData.products
          .filter((product) => product.item.type === 'Passeio')
          .reduce((prev, curr) => {
            prev.push(curr.booking.people || '--')
            return prev
          }, [])
          .join(' | ')

        bookingObs = transactionData.products
          .filter((product) => product.item.type === 'Passeio')
          .reduce((prev, curr) => {
            prev.push(curr.booking.observation || '--')
            return prev
          }, [])
          .join(' | ')

        bookingDates = transactionData.products
          .filter((product) => product.item.type === 'Passeio')
          .reduce((prev, curr) => {
            prev.push(curr.booking.date || '--')
            return prev
          }, [])
          .join(' | ')

        bookingTimes = transactionData.products
          .filter((product) => product.item.type === 'Passeio')
          .reduce((prev, curr) => {
            prev.push(curr.booking.time || '--')
            return prev
          }, [])
          .join(' | ')

        productDiscountObs = transactionData.products
          .reduce((prev, curr) => {
            prev.push(
              (curr.item.product_name || '') +
                ': ' +
                (curr.item.observation || '--')
            )
            return prev
          }, [])
          .join(' | ')

        productDiscounts = transactionData.products
          .reduce((prev, curr) => {
            prev.push(
              (curr.item.product_name || '') + ': ' + (curr.item.discount || '')
            )
            return prev
          }, [])
          .join(' | ')

        return [
          //id da transação
          transactionData.general.date.replaceAll('-', '') +
            '.' +
            transactionData.general.id +
            '.' +
            payment.id,

          //data previsão 'Carimbo de data/hora'
          `"${payment.p}"`,

          // 'Colaborador'
          `"${transactionData.general.user.name}"`,

          // 'Rótulo',
          `"${payment.t.replace('#', '').replace('(parcial)', '').trim()}"`,

          // Valor
          `"${Number(
            currPaymentData != undefined && currPaymentData.value
              ? currPaymentData.value
              : 0
          )
            .toFixed(2)
            .replace('.', ',')}"`,

          // 'forma de pagamento'
          currPaymentData != undefined &&
          currPaymentData.payment_method &&
          currPaymentData.payment_method.name
            ? currPaymentData.payment_method.name
            : '--',

          // 'CV'
          `"${
            currPaymentData != undefined && currPaymentData.cv
              ? currPaymentData.cv
              : '--'
          }"`.trim(),

          // 'AUT'
          `"${
            currPaymentData != undefined && currPaymentData.aut
              ? currPaymentData.aut
              : '--'
          }"`.trim(),

          // 'ID PIX'
          `"${
            currPaymentData != undefined && currPaymentData.pix_id
              ? currPaymentData.pix_id
              : '--'
          }"`.trim(),

          // 'NF'
          `"${
            currPaymentData != undefined && currPaymentData.invoice_number
              ? currPaymentData.invoice_number
              : '--'
          }"`.trim(),

          // Cliente: nome
          `"${
            currPaymentData != undefined && currPaymentData.customer_name
              ? currPaymentData.customer_name
              : '--'
          }"`.trim(),

          // Cliente: document
          `"${
            currPaymentData != undefined && currPaymentData.customer_document
              ? currPaymentData.customer_document
              : '--'
          }"`.trim(),

          // 'Passeios: Realizados'
          `"${bookingNames.replace('#', '').trim()}"`,

          // 'Passeios: Locais'
          `"${bookingPlaces.replace('#', '').trim()}"`,

          // 'Passeios: QTDE Pax\'s'
          `"${bookingPeople.replace('#', '').trim()}"`,

          // 'Passeios: Datas'
          `"${bookingDates.replace('#', '').trim()}"`,

          // 'Passeios: Horários'
          `"${bookingTimes.replace('#', '').trim()}"`,

          // 'Passeios:Obs:'
          `"${bookingObs.replace('#', '').trim()}"`,

          // 'Motivo dos descontos'
          `"${productDiscountObs.replace('#', '').trim()}"`,

          // 'Valor Total'
          `"${Number(transactionData.general.bill_total_value)
            .toFixed(2)
            .replace('.', ',')}"`,

          // 'DESCONTO'
          `"${Number(transactionData.general.bill_total_discount)
            .toFixed(2)
            .replace('.', ',')}"`,

          // Valor Final
          `"${Number(transactionData.general.bill_final_value)
            .toFixed(2)
            .replace('.', ',')}"`,

          // Situação
          //`"${(Number(transactionData.general.bill_total_value) - Number(transactionData.general.bill_total_discount) == Number(transactionData.general.bill_final_value)) ? 'PAGO' : 'PENDENTE'}"`
        ]
      })

      mat.unshift([
        'ID',
        'Carimbo de data/hora',
        'Colaborador',
        'Rótulo',
        '"Valor (R$ 0,00)"',
        'Forma de pagamento',
        'CV',
        'AUT',
        'ID PIX',
        'Nota Fiscal',
        'Cliente: nome',
        'Cliente: documento',
        'Passeios: Realizados',
        'Passeios: Locais',
        "Passeios: QTDE Pax's",
        'Passeios: Datas',
        'Passeios: Horários',
        'Produtos: Observações:',
        'Produtos: Motivos dos descontos',
        '"Conta: Valor Total (R$ 0,00)"',
        '"Conta: Desconto Total (R$ 0,00)"',
        '"Conta: Valor Final (R$ 0,00)"',
        // 'Situação'
      ])

      var universalBOM = '\uFEFF'
      let csvContent =
        'data:text/csv;charset=utf-8,' +
        universalBOM +
        mat
          .map((e) => e.join(';'))
          .join('\n')
          .toUpperCase()
      var encodedUri = encodeURI(csvContent)
      var link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute(
        'download',
        `${this.user.username}_janoo_receitas_financeiras_fiscal_-_${
          this.startDate
        }_-_${this.endDate}_${new Date().getTime()}.csv`
      )
      document.body.appendChild(link)
      link.click()
      this.perPageChange(currentPerpage)
      this.pagination.currentPage = currentPage
      setTimeout(() => {
        this.searchQuery = this.searchQueryValue
      }, 3000)
    },

    async downloadAsCSV(reladTransactions) {
      if (reladTransactions === true) {
        this.searchQueryValue = String(this.searchQuery)
        this.searchQuery = ''
        setTimeout(() => {
          this.$emit('loadTransactions')
          this.downloadAsCSV()
        }, 0)
        return
      }
      let currentPerpage = this.pagination.perPage
      let currentPage = this.pagination.currentPage
      let maxPerpage = JSON.parse(
        JSON.stringify(this.pagination.perPageOptions)
      ).pop()
      this.perPageChange(maxPerpage)
      const vm = this

      var mat = this.queriedData.map(function (val) {
        let transactionData = {}
        let bookingCategories = ''
        let bookingSubcategories = ''

        try {
          transactionData =
            typeof val.xfields === 'string'
              ? JSON.parse(val.xfields)
              : val.xfields || {}
        } catch (error) {
          console.log('erro ao gerar relatório', error)
          alert('erro ao gerar relatório')
          return
        }

        const passeios = (transactionData.products || []).filter(
          (product) => product.item && product.item.type === 'Passeio'
        )

        bookingCategories = passeios
          .reduce((prev, curr) => {
            prev.push(curr.item.category || '--')
            return prev
          }, [])
          .join(' | ')

        bookingSubcategories = passeios
          .reduce((prev, curr) => {
            prev.push(curr.item.subcategory || '--')
            return prev
          }, [])
          .join(' | ')

        return [
          //id da transação
          '' + val.id,
          //paid, quando pago. undefined para pendentes
          val.p ? val.p : '--',
          //third, descrição (rótulo) da entrada
          // val.t.replace(';', ','),
          `"${val.t.replace('#', '')}"`,
          //value
          `"${(val.v * 1).toFixed(2).replace('.', ',')}"`,
          //data previsão
          val.d,
          //forma de pagamento
          val.pm ? `${vm.user.paymentMethods[val.pm] || 'Outra'}` : '--',
          //id do agent/client
          `"${
            val.xfields && val.xfields.payments && val.xfields.payments[0]
              ? val.xfields.payments[0]['customer_document']
              : val.aid
              ? `"${val.aid}"`
              : '--'
          }"`,
          //Nome do agent/cliente
          `"${
            val.xfields && val.xfields.payments && val.xfields.payments[0]
              ? val.xfields.payments[0]['customer_name']
              : val.cid
              ? `"${val.cid}"`
              : '--'
          }"`,
          //Categoria
          `"${bookingCategories != '' ? bookingCategories : '--'}"`,
          //Subcategoria
          `"${bookingSubcategories != '' ? bookingSubcategories : '--'}"`,
        ]
      })

      mat.unshift([
        'ID',
        'Pago',
        'Descrição',
        'Valor',
        'Previsão',
        'Forma de pagamento',
        'Documento do Cliente',
        'Nome do Cliente',
        'Categoria',
        'Subategorias',
      ])

      var universalBOM = '\uFEFF'
      let csvContent =
        'data:text/csv;charset=utf-8,' +
        universalBOM +
        mat
          .map((e) => e.join(';'))
          .join('\n')
          .toUpperCase()
      var encodedUri = encodeURI(csvContent)
      var link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute(
        'download',
        `${this.user.username}_janoo_receitas_financeiras_-_${
          this.startDate
        }_-_${this.endDate}_${new Date().getTime()}.csv`
      )
      document.body.appendChild(link)

      link.click()
      this.perPageChange(currentPerpage)
      this.pagination.currentPage = currentPage
      setTimeout(() => {
        this.searchQuery = this.searchQueryValue
      }, 3000)
    },

    paginationChanged(page) {
      this.pagination.currentPage = page
    },

    perPageChange(perPage) {
      this.pagination.perPage = perPage
      this.pagination.currentPage = 1
    },

    formatterMoeda(row) {
      const amount = Number(row && row.v)
      const safeAmount = isFinite(amount) ? amount : 0
      return 'R$ ' + safeAmount.toFixed(2).replace('.', ',')
    },

    formatterDescricao(row) {
      if (!row) return ''
      const label = row.t || row.description || ''
      return row.pid != null ? `#${row.pid} - ${label}`.trim() : label
    },

    formatterData(row) {
      if (!row || row.p === undefined || row.p === null || row.p === '') {
        return '--'
      }
      const date = moment(row.p)
      return date.isValid() ? date.format('DD/MM/YYYY') : '--'
    },

    openInputModal() {
      this.financeiroStoreCommit({ mutation: 'RESET_TRANSACTION' })
      this.$emit('openTransactionModal')
    },

    async handleEdit(index, row) {
      this.isLoading = true
      const transaction_pid = row.pid
      const type = '1'
      this.financeiroStoreCommit({ mutation: 'RESET_TRANSACTION' })
      sessionStorage.removeItem('stored_transaction')

      await this.fetchTransactionById({
        pid: transaction_pid,
        type: type,
      }).then(() => {
        const transaction = this.transaction
        if (transaction && transaction.general && transaction.general.id) {
          this.isLoading = false
          this.$emit('openTransactionModal')
        }
        const products =
          transaction && Array.isArray(transaction.products)
            ? transaction.products
            : []
        const firstPayment =
          transaction && transaction.payments && transaction.payments[0]
        products.forEach((product) => {
          if (!product || !product.item || !product.booking) return
          if (['Passeio', 'Experiência','Evento'].includes(product.item.type)) {
            if (!product.booking.costumer && firstPayment) {
              product.booking.costumer = {
                name: firstPayment.customer_name,
                email: '',
                cpf: firstPayment.customer_document,
                phone: {
                  area_code: '',
                  number: '',
                },
              }
            }
          }
        })
      }).finally(() => {
        this.isLoading = false
      })
    },

    formatterDataPrevisao(row) {
      if (!row || !row.d) return '--'
      const date = moment(row.d)
      return date.isValid() ? date.format('DD/MM/YYYY') : '--'
    },

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },

    handleExpandChange(row, expandedRows) {
      const id = row.id
      const lastId = this.expandRowKeys[0]
      // disable mutiple row expanded
      this.expandRowKeys = id === lastId ? [] : [id]
    },

    handleRowStatus(row, rowIndex) {
      return ''
      // if(row.row.xfields != undefined && row.row.xfields.general.open === false){
      //   return 'closed-row'
      // }
      // else {
      //   return ''
      // }
    },

    recreateSearchableTable() {
      var transactions = (this.inputTransactions || []).filter(function (
        value
      ) {
        return value != null
      })

      transactions = transactions.map(function (value) {
        var xfields = value.xfields

        if (typeof xfields === 'string') {
          try {
            xfields = JSON.parse(xfields)
            value.xfields = xfields
          } catch (error) {
            xfields = {}
          }
        }

        if (!xfields) xfields = {}

        var payments = Array.isArray(xfields.payments) ? xfields.payments : []
        value.searchable = payments.map(function (val) {
          if (!val) return []
          val.method = (val.payment_method && val.payment_method.name) || ''
          return Object.values(val).filter(
            (i) => typeof i == 'string' && i.length > 0
          )
        })

        var products = Array.isArray(xfields.products) ? xfields.products : []
        const productValues = products
          .flatMap(function (product) {
            if (!product) return []

            const booking = product.booking || {}
            const costumer = booking.costumer || {}
            const productPlace = booking.product_place || {}

            return [
              booking.booking_code,
              product.item && product.item.produc_name,
              costumer.name,
              costumer.email,
              costumer.cpf,
              costumer.phone && costumer.phone.number,
              booking.observation,
              typeof productPlace === 'string' ? productPlace : null,
              productPlace.name,
            ]
          })
          .filter(function (item) {
            return item != null && String(item).length > 0
          })

        ;[value.t, value.name, value.cid, value.cat, value.des, value.third]
          .forEach(function (item) {
            if (item != null && String(item).length > 0) productValues.push(item)
          })

        value.searchable.push(...productValues)
        value.searchable = [...new Set(value.searchable.flat())]
        return value
      })

      transactions.length > 0
        ? this.setBillItems(transactions)
        : this.setBillItems([])

      this.createFuseSearch([
        'name',
        'cat',
        'cid',
        'd',
        'p',
        't',
        'v',
        'xfields',
        'xfields.general.id',
        'xfields.general.label',
        'xfields.general.user.name',
        'xfields.general.bill_status',
        'xfields.general.bill_total_value',
        'xfields.general.bill_final_value',
        'xfields.general.bill_total_discount',
        'xfields.general.observation',
        'searchable',
      ])
    },
  },

  mounted() {
    this.recreateSearchableTable()
  },
}
</script>

<style>
@import url('//unpkg.com/element-ui@2.4.11/lib/theme-chalk/index.css');

.card .table td,
.card .table th,
.card .el-table td,
.card .el-table th {
  padding: 0;
  height: 2.5rem;
}

.card .el-table .el-table__body tr td:first-child {
  border-left: 2px solid #fff;
  padding-left: 1rem !important;
}

.card .el-table .el-table__body tr:hover td:first-child {
  border-left: 2px solid #12576e !important;
}

.card .el-table .cell {
  padding: 0;
  height: 100%;
}

.expand-content {
  margin-left: 40px;
}

.table-cell-clickable {
  cursor: pointer;
  width: 100%;
  height: 100%;
  padding-left: 0px !important;
  padding-right: 0px !important;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.dropdown-input-transaction .dropdown-menu {
  box-shadow: none !important;
  background-color: #a7aa37;
}

.closed-row {
  color: #fff;
  background-color: #3aaf85 !important;
}

.dropdown-input-transaction .dropdown-item.active,
.dropdown-input-transaction .dropdown-item:active,
.dropdown-input-transaction .dropdown-item:active {
  color: #fffffff2;
}
</style>
